import { render, staticRenderFns } from "./Animales.vue?vue&type=template&id=8094730c&scoped=true&"
import script from "./Animales.vue?vue&type=script&lang=js&"
export * from "./Animales.vue?vue&type=script&lang=js&"
import style0 from "./Animales.vue?vue&type=style&index=0&id=8094730c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8094730c",
  null
  
)

export default component.exports